module.exports = __webpack_public_path__ + "static/media/MongoDB.d9af6ed3.png";